import * as React from "react";
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import Typography from '@mui/material/Typography';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Button from "@mui/material/Button";
import CloseIcon from '@mui/icons-material/Close';
import PieChartIcon from '@mui/icons-material/PieChart';
import moment from "moment";
import CustomSelect from "../CustomComponents/CustomSelect";
import { dateTransformation } from '../../utils.js'
import { Link } from 'react-router-dom';
import {logger, customBodyForExcelReport,handleExport} from '../../utils';
const ExcelJS = require('exceljs');
import { makeStyles } from "@mui/styles";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';

export default function POInvoiceBreakdown({ data}) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [ValueAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState('');
    const [succeed, setSucceed] = React.useState(false);
    const [list, setList] = React.useState([])
 
    const handleAlertClose = () => {
        setAlert(false);
    };

    const getTotal = () => {
        let total = 0
        list.map((item, index) => {
            total += item.Amount
        })
        return total.toFixed(2)
    };

    const handleClickOpen = () => {
        logger(data)
        setRefresh(true)
        setOpen(true);
    };
    const onTrigger = React.useCallback(() => {
    })

    const handleClose = () => {
        setOpen(false);
    };

	  
    
    const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));
    const classes = pageStyles();

	
	const BillList = async () => {
						    const batchSize = 50;
						    const numBatches = Math.ceil(list.length / batchSize); 
						    for (let i = 0; i < numBatches; i++) {
						        const startIndex = i * batchSize;
						        const endIndex = Math.min(startIndex + batchSize, list.length);
						        const batchEntries = list.slice(startIndex, endIndex); 
						        const batchTimeEntryIDs = batchEntries.map(item => item.time_entryID); 
						
						        logger(`Updating invoices for batch ${i + 1}:`, batchTimeEntryIDs);
						        try {
						            const response = await fetch("api/invoice/list", {
						                method: 'PATCH',
						                headers: { 'Content-Type': 'application/json' },
						                body: JSON.stringify({
						                    "InvoiceID": data.ID,
						                    "List": batchTimeEntryIDs
						                })
						            });
						
						            if (!response.ok) {
						                throw new Error(`Failed to update invoices for batch ${i + 1}`);
						            }
						        } catch (error) {
						            console.error(error);
						        }
						    }
						setRefresh(true);
						    setOpen(false);
						};




    React.useEffect(() => {

        if (refresh) {
            fetch(`api/invoiceBy/${data.ID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
                    logger("get invoices", json);
                    setList(json)
                })

            setRefresh(false);
        }
    })

    const columns = [
        {
            name: "InvoiceNumber",
            label: "Invoice Number",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Amount",
            label: "Amount",
            options: {
                filter: false,
                sort: true,
            }
        },
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 20; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'POInvoiceBreakdown.xlsx'})
			return false;
		},
        customToolbar: () => (
            <div>
            {(data.IsBilled===0 || data.IsBilled=== false) &&
                <Button variant="contained" style={ data.IsBilled? { color: "#fff" } : {}} onClick={() => {
                    if (list.filter(item => { return item.VerifyStatus === 1 }).length === list.length) {
                        setAlertText('Permanently assign these entries to this Invoice')
                        setAlert(true)
                        setSucceed(true)
                    } else {
                        setAlertText('Permanently cannot assign these entries to this Invoice yet')
                        setAlert(true)
                        setSucceed(false)
                    }
                }}>
                    Bill List
                </Button>
                }
            </div>
            )
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div>
            <Tooltip title="Details" placement="top-end">
            <IconButton variant="contained" onClick={handleClickOpen}>
                <PieChartIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullScreen>
                <DialogContent>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                    <MuiThemeProvider theme={muiThemeDesign}>
                        <MUIDataTable className="invoiceTable"
                            title={
                                <Typography variant="h6" style={{ color: "white" }}>
                                    Invoice total:${getTotal()} PO Amount:${data.Amount}
                                </Typography>
                            }
                            data={list}
                            columns={columns}
                            options={options}

                        />
                    </MuiThemeProvider>
                </DialogContent>
                <Dialog
                    open={ValueAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Bill Invoice"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {alertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={succeed} component={Link} to="/Summary" onClick={() => { setAlert(false) }}>Go to Summary</Button>
                        <Button onClick={() => { setAlert(false) }}>Cancel</Button>
                        <Button disabled={!succeed} onClick={() => {
                            setAlert(false);
                            BillList();
                            onTrigger();
                        }} autoFocus>
                            ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </Dialog>
        </div>
    );
}